<template>
  <div>

    <el-alert class="noty" :closable="false">
      Данных о похожих термограмм нет
    </el-alert>

  </div>
</template>

<script>
export default {
  name: 'SimilarHeatMap',
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.noty {
  margin-top: 24px;
}
</style>